// extracted by mini-css-extract-plugin
export default {"top":"top_top__GohuY"};